import React, { forwardRef } from "react";
import { CurrencyInputType } from "./currency-input.types";
import { TextInputBase } from "../../text-input/text-input-base.jsx";
import { formatCurrency } from "../../text-input/util/currency-input.util";

export interface CurrencyInputWithForwardRef
  extends React.ForwardRefExoticComponent<
    CurrencyInputType & React.RefAttributes<HTMLInputElement>
  > {}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputType>(
  (
    { name = "currency-input", ...props }: CurrencyInputType,
    ref
  ): React.ReactElement => {
    return (
      <TextInputBase
        name={name}
        {...props}
        isCurrency={true}
        type={"tel"}
        ref={ref}
        formatInputValue={formatCurrency}
      />
    );
  }
) as CurrencyInputWithForwardRef;

CurrencyInput.displayName = "CurrencyInput";
